import { useCallback, useEffect, useMemo } from 'react';

export const CHANGELOG_STORAGE_KEY = 'changelog';

export const useChangelogVersion = () => {
  const storedVersion = localStorage.getItem(CHANGELOG_STORAGE_KEY);
  const latestChangelogVersion = String(import.meta.env.VITE_APP_VERSION);

  useEffect(() => {
    if (!storedVersion) {
      localStorage.setItem(CHANGELOG_STORAGE_KEY, latestChangelogVersion);
    }
  }, [latestChangelogVersion, storedVersion]);

  const updateLatestChangelogVersion = useCallback(() => {
    if (storedVersion !== latestChangelogVersion) {
      localStorage.setItem(CHANGELOG_STORAGE_KEY, latestChangelogVersion);
    }
  }, [latestChangelogVersion, storedVersion]);

  return useMemo(
    () => ({
      latestChangelogVersion,
      storedVersion,
      updateLatestChangelogVersion,
    }),
    [latestChangelogVersion, storedVersion, updateLatestChangelogVersion],
  );
};
